module.exports = __webpack_public_path__ + "static/media/green-rectangle.285143f0.svg";